// eslint-disable-next-line import/prefer-default-export
export const SET_WASHER_LIST = 'SET_WASHER_LIST';
export const SET_WASHER_INFO = 'SET_WASHER_INFO';
